import { styled } from '@material-ui/core';
import { Calendar } from 'react-multi-date-picker';
//export const russian: CalendarLocalization = {
//    name: 'ru',
//    startYear: 1,
//    yearLength: 365,
//    epoch: 0,
//    century: 0,
//    weekStartDayIndex: 0,
//    getMonthLengths: function(isLeap: boolean): number[] {
//        throw new Error('Function not implemented.')
//    },
//    isLeap: function(year: number): boolean {
//        throw new Error('Function not implemented.')
//    },
//    getLeaps: function(currentYear: number): number[] | [] {
//        throw new Error('Function not implemented.')
//    },
//    getDayOfYear: function(date: DateObject): number {
//        throw new Error('Function not implemented.')
//    },
//    getAllDays: function(date: DateObject): number {
//        throw new Error('Function not implemented.')
//    },
//    guessYear: function(days: number, currentYear: number): number {
//        throw new Error('Function not implemented.')
//    }
//}
export const russian = {
    name: 'ru',
    months: [
        ['Январь', 'Янв'],
        ['Февраль', 'Фев'],
        ['Март', 'Мар'],
        ['Апрель', 'Апр'],
        ['Май', 'Май'],
        ['Июнь', 'Июн'],
        ['Июль', 'Июл'],
        ['Август', 'Авг'],
        ['Сентябрь', 'Сен'],
        ['Октябрь', 'Окт'],
        ['Ноябрь', 'Ноя'],
        ['Декабрь', 'Дек'],
    ],
    weekDays: [
        ['Суббота', 'Сб'],
        ['Воскресенье', 'Вс'],
        ['Понедельник', 'Пн'],
        ['Вторник', 'Вт'],
        ['Среда', 'Ср'],
        ['Четверг', 'Чт'],
        ['Пятница', 'Пт'],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: []
};
export const StyledCalendar = styled(Calendar)(({ theme }) => ({
    fontFamily: theme.typography.fontFamily,
    '&.rmdp-wrapper, & .rmdp-month-picker, & .rmdp-year-picker, & .rmdp-time-picker div input, .rmdp-container &.ep-arrow::after': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.secondary.light,
        mx: 'auto',
    },
    '& .rmdp-day:not(.rmdp-deactive), & .rmdp-time-picker div .rmdp-am, & .rmdp-header-values, & .rmdp-panel-header': {
    //color: theme.palette.primary.light,
    },
    '& .rmdp-header-values': {
        fontWeight: 'bold',
    },
    '& .rmdp-day, & .rmdp-week-day': {
        width: '40px',
        height: '40px',
        padding: '5px',
    },
    '& .rmdp-day span, & .rmdp-header, & .rmdp-month-name': {
        fontSize: '13px',
    },
    '& .rmdp-day span.sd': {
        fontSize: '13px',
        fontWeight: 'bold',
    },
    '& .rmdp-day.rmdp-range.start, & .rmdp-day.rmdp-range.end, & .rmdp-day.rmdp-range:has(.rmdp-single)': {
        color: theme.palette.common.white,
    },
    '& .rmdp-panel-body li': {
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: `0 0 5px ${theme.palette.primary.main}`,
        background: `${theme.palette.primary.main} !important`,
        //boxShadow: theme.shadows[5],
    },
    '& .rmdp-day.rmdp-deactive, & .rmdp-day.rmdp-disabled': {
        color: theme.palette.text.disabled,
    },
    '& .rmdp-day.rmdp-disabled span': {
        textDecoration: 'line-through',
    },
    //'& .rmdp-day:not(.rmdp-disabled):not(.rmdp-range)': {
    //    backgroundColor: `#D0D6FF !important`,
    //},
    '.rmdp-container &.ep-arrow[direction="top"]': {
        borderBottom: `1px solid ${theme.palette.secondary.main}`,
    },
    '.rmdp-container &.ep-arrow[direction="left"]': {
        borderRight: `1px solid ${theme.palette.secondary.main}`,
    },
    '.rmdp-container &.ep-arrow[direction="right"]': {
        borderLeft: `1px solid ${theme.palette.secondary.main}`,
    },
    '.rmdp-container &.ep-arrow[direction="bottom"]': {
        borderTop: `1px solid ${theme.palette.secondary.main}`,
    },
    '&.rmdp-wrapper.rmdp-shadow': {
        border: `1px solid ${theme.palette.secondary.main}`,
        boxShadow: `0 0 5px ${theme.palette.secondary.main}`,
        //...(error && {
        //    borderColor: theme.palette.error.main,
        //}),
    },
    '& .rmdp-week-day': {
        color: theme.palette.common.black,
        fontWeight: 'bold',
    },
    '& .rmdp-day.rmdp-deactive': {
        color: '#999',
    },
    '& .rmdp-range': {
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: '#ebf4f8',
        boxShadow: 'unset',
        color: theme.palette.common.black,
    },
    '& .rmdp-arrow': {
        border: `solid ${theme.palette.common.black}`,
        borderWidth: `0 3px 3px 0`,
        height: '4px',
        width: '4px',
        padding: '3px',
        marginTop: '16px',
    },
    '& .rmdp-arrow-container': {
        width: '40px',
        height: '40px',
    },
    '& .rmdp-arrow-container:hover': {
        borderRadius: '4px',
        backgroundColor: theme.palette.grey[200],
        boxShadow: `none`,
    },
    '& .rmdp-panel-body::-webkit-scrollbar-thumb': {
        background: `${theme.palette.primary.main} !important`,
    },
    '& .rmdp-day.rmdp-today span': {
        backgroundColor: theme.palette.info.main,
    },
    '& .rmdp-rtl .rmdp-panel': {
        borderLeft: 'unset',
        borderRight: `1px solid ${theme.palette.secondary.main}`,
    },
    '& .rmdp-day.rmdp-selected span:not(.highlight)': {
        backgroundColor: theme.palette.primary.main,
        boxShadow: theme.shadows[3],
    },
    '& .rmdp-day:not(.rmdp-day-hidden) span:hover': {
        background: `${theme.palette.primary.light} !important`,
    },
    '& .b-deselect': {
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.common.white,
    },
    '& .rmdp-action-button': {
        color: theme.palette.primary.main,
    },
    '& .rmdp-button:not(.rmdp-action-button)': {
        backgroundColor: theme.palette.primary.main,
    },
    '& .rmdp-button:not(.rmdp-action-button):hover': {
        backgroundColor: theme.palette.grey[600],
    },
    '& .rmdp-range-hover.start, & .rmdp-range.start, & .rmdp-range:has(.rmdp-single)': {
        borderBottomLeftRadius: '4px',
        borderTopLeftRadius: '4px',
        backgroundColor: `${theme.palette.primary.main} !important`,
    },
    '& .rmdp-range-hover.end, & .rmdp-range.end, & .rmdp-range:has(.rmdp-single)': {
        borderBottomRightRadius: '4px',
        borderTopRightRadius: '4px',
        backgroundColor: `${theme.palette.primary.main} !important`,
    },
    //'& .rmdp-range-hover:not(.start):not(.end), & .rmdp-range:not(.start):not(.end)': {
    //    backgroundColor: '#ebf4f8',
    //},
}));
